import React, { useEffect, useMemo, useState } from 'react';
import styles from './UIGameTradeOfferActiveOffer.module.scss';
import { CardEnum, PlayerColor, TradeResponseStatus } from '@colonist/game-states';
import { TradeValidator } from '@colonist/game-mechanic-validators';
import { UIGameCardInventory } from '../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import IconTradeArrowGreen from '@static/images/icon_trade_arrow_green.svg';
import IconTradeArrowRed from '@static/images/icon_trade_arrow_red.svg';
import { Avatar } from '../../../common/Avatar/index.ts';
import { LobbyImage } from '@colonist/types';
import { UIGameTradeOfferRejectTradeButton } from '../UIGameTradeOfferRejectTradeButton/index.ts';
import { UIGameTradeOfferAcceptTradeButton } from '../UIGameTradeOfferAcceptTradeButton/index.ts';
import { UIGameTradeOfferCounterOfferButton } from '../UIGameTradeOfferCounterOfferButton/index.ts';
import { UIGameTradeOfferRespondTradeButton } from '../UIGameTradeOfferRespondTradeButton/index.ts';
import clsx from 'clsx';
import { AudioManager, AudioType } from '@colonist/audio';
import { T, Tooltip } from '@colonist/ui';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { TradeEmbargoControllerReader } from '@colonist/game-base-types';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
const getCardsToDisable = (myCardState, requiredCardState)=>{
    const cardsToDisable = {};
    for (const [cardEnum, requiredCardCount] of Object.entries(requiredCardState)){
        var _myCardState_cardEnum;
        const myCardCount = (_myCardState_cardEnum = myCardState[cardEnum]) !== null && _myCardState_cardEnum !== void 0 ? _myCardState_cardEnum : 0;
        const numberOfCardsToDisable = requiredCardCount - myCardCount;
        const isAnyResourceCard = Number(cardEnum) === CardEnum.AnyResource;
        if (numberOfCardsToDisable > 0 && !isAnyResourceCard) cardsToDisable[cardEnum] = numberOfCardsToDisable;
    }
    return cardsToDisable;
};
const getAvatarTradeStatusTooltipKey = (tradeStatus)=>{
    switch(tradeStatus){
        case TradeResponseStatus.Accepted:
            return 'strings:game.tooltips.tradeOfferPlayerAccepted';
        case TradeResponseStatus.Rejected:
            return 'strings:game.tooltips.tradeOfferPlayerRejected';
        case TradeResponseStatus.PendingResponse:
            return 'strings:game.tooltips.tradeOfferPlayerPending';
        case TradeResponseStatus.Embargoed:
            return 'strings:game.tooltips.tradeOfferPlayerBlockedTrading';
    }
};
export const UIGameTradeOfferActiveOfferReceivingHalf = ({ tradeValidator, disableTooltips })=>{
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const myColor = useGameStore((state)=>state.myColor);
    const tradeState = useGameStore((state)=>state.gameState.tradeState);
    const { playerValidators, getPlayerValidator } = usePlayerValidators();
    const recipientColor = tradeValidator.getRecipientColor(myColor);
    const isAllPlayersIcon = recipientColor === PlayerColor.None;
    const recipient = !isAllPlayersIcon ? getPlayerValidator(recipientColor) : null;
    const receivingCardEnums = tradeValidator.getReceivingResources(myColor);
    const receivingCards = useMemo(()=>cardEnumsToCardState(receivingCardEnums), [
        receivingCardEnums
    ]);
    const amITradeExecutor = tradeValidator.tradeExecutorColor == myColor;
    const playersExceptRecipientAndMe = playerValidators.filter((playerValidator)=>{
        const playerColor = playerValidator.color;
        if (playerColor === tradeValidator.getRecipientColor(myColor)) return false;
        if (playerColor === myColor) return false;
        if (isMyColorSpectator && playerColor === myColor) return false;
        return true;
    });
    const shouldShowAvatarsWithStatus = tradeValidator.isOpenEndedTrade() || !amITradeExecutor || isMyColorSpectator;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.receivingHalfContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.leftContainer
    }, recipient ? /*#__PURE__*/ React.createElement(Avatar, {
        image: recipient.displayIcon,
        color: recipientColor,
        profilePictureUrl: recipient.profilePictureUrl,
        className: styles.avatar
    }) : /*#__PURE__*/ React.createElement(Avatar, {
        image: LobbyImage.Players,
        hideBackground: true,
        className: styles.avatar
    }), /*#__PURE__*/ React.createElement("img", {
        src: IconTradeArrowGreen,
        className: styles.receivingArrow
    }), /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        cardState: receivingCards,
        animate: false,
        enablePartition: false,
        cardSize: "sm",
        className: styles.cardStack
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.rightContainer
    }, shouldShowAvatarsWithStatus && playersExceptRecipientAndMe.map((player)=>{
        const playerResponseState = tradeValidator.getPlayerResponseState(player.color);
        if ((playerResponseState === null || playerResponseState === void 0 ? void 0 : playerResponseState.responseStatus) == null) return null;
        const isEmbargoed = (playerResponseState === null || playerResponseState === void 0 ? void 0 : playerResponseState.responseStatus) === TradeResponseStatus.Embargoed;
        let playerUsername = player.username;
        var _recipient_username;
        let recipientUsername = (_recipient_username = recipient === null || recipient === void 0 ? void 0 : recipient.username) !== null && _recipient_username !== void 0 ? _recipient_username : '';
        if (isEmbargoed && recipient) {
            const isPlayer1EmbargoedRecipient = TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(tradeState.embargoState, player.color, recipientColor);
            if (!isPlayer1EmbargoedRecipient) {
                playerUsername = recipient.username;
                recipientUsername = player.username;
            }
        }
        const tooltipText = {
            key: getAvatarTradeStatusTooltipKey(playerResponseState.responseStatus),
            options: {
                playerUsername: playerUsername,
                recipientPlayerName: recipientUsername
            }
        };
        return /*#__PURE__*/ React.createElement(Tooltip, {
            key: player.color,
            content: /*#__PURE__*/ React.createElement(T, {
                id: tooltipText
            }),
            disabled: disableTooltips,
            centerText: true
        }, /*#__PURE__*/ React.createElement(Avatar, {
            image: player.displayIcon,
            color: player.color,
            profilePictureUrl: player.profilePictureUrl,
            className: styles.avatar,
            tradeResponseStatus: playerResponseState.responseStatus,
            isEmbargoed: isEmbargoed
        }));
    })));
};
export const UIGameTradeOfferActiveOfferGivingHalf = ({ tradeValidator, isGameInBackground, disableTooltips })=>{
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    const myColor = useGameStore((state)=>state.myColor);
    const { getPlayerValidator } = usePlayerValidators();
    const [isOtherButtonsClicked, setIsOtherButtonsClicked] = useState(false);
    const amITradeExecutor = tradeValidator.tradeExecutorColor == myColor;
    const givingColor = myColor;
    const givingPlayerValidator = !isMyColorSpectator ? getPlayerValidator(givingColor) : null;
    const givingCardEnums = tradeValidator.getGivingResources(myColor);
    const givingCards = useMemo(()=>cardEnumsToCardState(givingCardEnums), [
        givingCardEnums
    ]);
    const cardsToDisable = useMemo(()=>{
        if (!givingPlayerValidator) return {};
        const myCardsInventory = cardEnumsToCardState(givingPlayerValidator.resourceCards.cards);
        return getCardsToDisable(myCardsInventory, givingCards);
    }, [
        givingCards,
        givingPlayerValidator
    ]);
    const playerResponseButtons = useMemo(()=>{
        if (!amITradeExecutor) return null;
        const playerResponseStates = tradeValidator.getPlayerResponseStates();
        return playerResponseStates.map((playerResponse)=>/*#__PURE__*/ React.createElement(UIGameTradeOfferRespondTradeButton, {
                key: playerResponse.player,
                playerResponse: playerResponse,
                tradeValidator: tradeValidator,
                disableTooltips: disableTooltips
            }));
    }, [
        tradeValidator,
        amITradeExecutor,
        disableTooltips
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.givingHalfContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.leftContainer
    }, givingPlayerValidator ? /*#__PURE__*/ React.createElement(Avatar, {
        image: givingPlayerValidator.displayIcon,
        color: givingColor,
        profilePictureUrl: givingPlayerValidator.profilePictureUrl,
        className: styles.avatar
    }) : /*#__PURE__*/ React.createElement(Avatar, {
        image: LobbyImage.Players,
        hideBackground: true,
        className: styles.avatar
    }), /*#__PURE__*/ React.createElement("img", {
        src: IconTradeArrowRed,
        className: styles.givingArrow
    }), /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        cardsToDisable: cardsToDisable,
        cardState: givingCards,
        animate: false,
        enablePartition: false,
        cardSize: "sm",
        className: styles.cardStack
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.rightContainer
    }, playerResponseButtons, /*#__PURE__*/ React.createElement(UIGameTradeOfferCounterOfferButton, {
        tradeValidator: tradeValidator,
        setIsOtherButtonsClicked: setIsOtherButtonsClicked,
        disableTooltips: disableTooltips
    }), /*#__PURE__*/ React.createElement(UIGameTradeOfferRejectTradeButton, {
        setIsOtherButtonsClicked: setIsOtherButtonsClicked,
        isOtherButtonsClicked: isOtherButtonsClicked,
        tradeValidator: tradeValidator,
        isGameInBackground: isGameInBackground,
        disableTooltips: disableTooltips
    }), /*#__PURE__*/ React.createElement(UIGameTradeOfferAcceptTradeButton, {
        setIsOtherButtonsClicked: setIsOtherButtonsClicked,
        tradeValidator: tradeValidator,
        disableTooltips: disableTooltips
    })));
};
export const UIGameTradeOfferActiveOffer = ({ offer, className, isGameInBackground, disableTooltips })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const { playerValidators, getPlayerValidator } = usePlayerValidators();
    const tradeState = useGameStore((state)=>state.gameState.tradeState);
    const currentStateValidator = useCurrentStateValidator();
    const tradeValidator = new TradeValidator(offer, currentStateValidator.currentTurnPlayers, playerValidators, tradeState.embargoState);
    const isCounterOffer = offer.counterOfferInResponseToTradeId != undefined;
    const creatorValidator = getPlayerValidator(offer.creator);
    useEffect(()=>{
        const canIAcceptTrade = tradeValidator.getAcceptTradeActionStatus(myColor).canTakeAction;
        const soundToPlay = canIAcceptTrade ? AudioType.OfferAcceptable : AudioType.OfferNotAcceptable;
        AudioManager.play(soundToPlay);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, isCounterOffer && /*#__PURE__*/ React.createElement("div", {
        className: styles.counterOfferContainer
    }, /*#__PURE__*/ React.createElement(Avatar, {
        image: creatorValidator.displayIcon,
        color: creatorValidator.color,
        profilePictureUrl: creatorValidator.profilePictureUrl,
        className: styles.avatar
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.tradeContainer
    }, /*#__PURE__*/ React.createElement(UIGameTradeOfferActiveOfferReceivingHalf, {
        tradeValidator: tradeValidator,
        disableTooltips: disableTooltips
    }), /*#__PURE__*/ React.createElement(UIGameTradeOfferActiveOfferGivingHalf, {
        tradeValidator: tradeValidator,
        isGameInBackground: isGameInBackground,
        disableTooltips: disableTooltips
    })));
};
